import React from "react";
import {
  getBestLevel,
  getLevelPrefix,
  isLevelAttained,
} from "@sscs/report/utils";
import { RLChecksReport, SDLCMetadata } from "@sscs/types";
import { LevelDiamond, VerticalDivider } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import styles from "./version.module.scss";

type LevelsProps = {
  inhibitors: SDLCMetadata.inhibit_object_t;
  checks: RLChecksReport.scan_check_t[];
};

const Levels = ({
  inhibitors,
  checks,
}: LevelsProps): React.JSX.Element | null => {
  const bestLevel = getBestLevel(inhibitors);
  const levelPrefix = getLevelPrefix(inhibitors.customized);
  const finalCheck = checks.find((check) => check.final);

  if (!finalCheck) {
    return null;
  }

  return (
    <div className={styles["common-container"]}>
      <strong>SAFE levels</strong>
      <VerticalDivider />
      <span>Scan level:&nbsp;</span>
      <strong>{finalCheck.label}</strong>
      <span>&nbsp;&nbsp;|&nbsp;&nbsp;Best Level:&nbsp;</span>
      <strong>
        {levelPrefix}
        {bestLevel}
      </strong>
      <VerticalDivider />
      <div className={styles.levels}>
        <div className={styles.start} />
        {[1, 2, 3, 4, 5].map((level) => {
          const isAttained = isLevelAttained(inhibitors, level);

          return (
            <React.Fragment key={level}>
              <div
                className={getClassName(styles.line, {
                  [styles["attained-line"]]: isAttained,
                  [styles["first-line"]]: level === 1,
                })}
              />
              <LevelDiamond
                level={level}
                prefix={levelPrefix}
                attained={isAttained}
              />
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Levels;
